import { useEffect, useState } from 'react'
import { initProductRating } from '../lib/productRatingInitializer'
import { RATING_CLASS_NAME } from '../lib/constants'
import { InfiniteData } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { createLanguageRegionLocale } from '~/lib/createLanguageRegionLocale'
import { DEFAULT_LOCALE } from '~/config/constants'
import ProductRatingScript from '../ProductRatingScript'
import { useTranslation } from 'next-i18next'

type Props = {
  enabled?: boolean
  infiniteData?: InfiniteData<any>
  forPDP?: boolean
  sku?: string | undefined | null
}

const ProductRatingLoader: React.FC<Props> = ({
  enabled = true,
  forPDP = false,
  infiniteData,
  sku,
}) => {
  const router = useRouter()
  const { t } = useTranslation()
  const [loadedForProduct, setLoadedForProduct] = useState<string | undefined | null>()
  const finalLocale = router.locale ? createLanguageRegionLocale(router.locale) : DEFAULT_LOCALE
  const hasRatingSnippet = typeof (window as any)?.ratingSnippet === 'function'

  useEffect(() => {
    if (hasRatingSnippet && (!!infiniteData || (forPDP && sku !== loadedForProduct)) && enabled) {
      initProductRating(RATING_CLASS_NAME, finalLocale, {
        singular: t('review'),
        plural: t('reviews'),
      })
      setLoadedForProduct(sku)
    }
  }, [hasRatingSnippet, enabled, infiniteData, forPDP, sku, loadedForProduct])

  return <ProductRatingScript />
}

export default ProductRatingLoader
